export default __webpack_public_path__ + "f59d33fb9f8b0b3a4ba854c3d0cc4606.svg";